/* BB1 G Truslove - reusable functions */

define('Tools', [
    'jQuery', 'Utils', 'underscore', 'SC.Configuration', 'Tools', 'js.cookie', "Code25.CaterpartsGlobal.ConsoleErrors"
],
    function (
        jQuery, Utils, _, Configuration, Tools, Cookies, ConsoleErrors
    ) {

        'use strict';

        var ProfileModel = require('Profile.Model'); //Depreciated
        if (ProfileModel.ProfileModel) {
            ProfileModel = ProfileModel.ProfileModel;
        }

        function splitMessage(message) {
            if (message) {
                var split, line, left, lastleft;
                if (Array.isArray(message)) {
                    var body = "";
                    for (var i = 0; i < message.length; i++) {
                        if (message[i].responseJSON && message[i].responseJSON.errorMessage) {
                            line = message[i].responseJSON.errorMessage;
                        } else {
                            line = (message[i] || "").toString();
                        }
                        split = line.indexOf("|");
                        if (split > -1) {
                            left = line.substring(0, split);
                            if (left != lastleft) {
                                lastleft = left;
                                body += "<p>" + Utils.translate(line.substring(0, split)) + "</p>";
                            }
                            body += "<p style=\"color:#666;\">" + line.substring(split + 1) + "</p>";
                        } else {
                            body += "<p>" + Utils.translate(line) + "</p>";
                        }
                    }
                    message = body;
                } else {
                    line = (message || "").toString();
                    try {
                        if (line.indexOf("{") > -1) {
                            line = JSON.parse(line);
                            line = line.message || line.error || line.details || JSON.stringify(line);
                        }
                    } catch (err) {

                    }
                    split = line.indexOf("|");
                    if (split > -1) {
                        message = "<p>" + Utils.translate(line.substring(0, split)) + "</p><p style=\"color:#666;\">" + line.substring(split + 1) + "</p>";
                    }
                }
            }
            return message;
        }


        function showErrorInModal(application, title, message) {

            message = splitMessage(message);
            var view = new Backbone.View({
                application: application
            });

            view.title = title;
            view.render = function () {
                this.$el.append('<p class="error-message">' + message + '</p><br /><div class="text-center"><button class="button-primary button-large" data-dismiss="modal">' + Utils.translate('OK') + '</button></div>');
            };
            view.showInModal();
        }
        function showPayInvoicesInModal(application, title, message) {

            message = splitMessage(message);
            var view = new Backbone.View({
                application: application
            });

            view.title = title;
            view.render = function () {
                this.$el.append('<p class="error-message">' + message + '</p><br /><div class="text-center"><a class="button-primary button-large" href="' + SC.SESSION.touchpoints.customercenter + '?fragment=invoices">' + Utils.translate('Pay My Invoices') + '</a><button class="button-secondary button-large button-positioning-stack2next" data-dismiss="modal" >' + Utils.translate('Cancel') + '</button></div>');
            };
            view.showInModal();
        }

        function showSuccessInModal(application, title, message) {

            message = splitMessage(message);
            var view = new Backbone.View({
                application: application
            });

            view.title = title;
            view.render = function () {
                this.$el.append('<p class="success-message">' + message + '</p><br /><div class="text-center"><button class="button-primary button-large" data-dismiss="modal">' + Utils.translate('OK') + '</button></div>');
            };
            view.showInModal();
        }

        function showConfirmInModal(application, title, message, success, buttonText, cancelText) {

            message = splitMessage(message);
            var view = new Backbone.View({
                application: application
            });

            view.title = title;
            view.render = function () {
                this.$el.append('<p class="success-message">' + message + '</p><br /><div class="text-center"><button class="button-primary button-large confirm" data-dismiss="modal" >' + Utils.translate(buttonText || 'Confirm') + '</button><button class="button-secondary button-large button-positioning-stack2next" data-dismiss="modal" >' + Utils.translate(cancelText || 'Cancel') + '</button></div>');

                if (success) {
                    this.$el.find(".confirm").click(success);
                }
            };
            view.showInModal();
        }

        function trim(text) { //trim leading and ending spaces
            return text.replace(/^\s+|\s+$/g, '')
        }


        function endsWith(text, value) { //does the text end with value?
            if (!text || !value) {
                return false;
            }
            if (text.length >= value.length) {
                return text.substring(text.length - value.length) == value;
            }
            return false;
        }

        function isLive() {
            var host = SC.ENVIRONMENT.currentHostString;
            if (!host || host.indexOf("code25.com") > -1 || document.location.href.indexOf("local.ssp") > -1) {
                return false;
            }
            return true;
        }

        function getValue(name) { //get a value from localstorage if available

            if (typeof (Storage) !== "undefined") {
                return localStorage.getItem(name);
            }
        }

        function setValue(name, value) { //set a value in localstorage if available

            if (typeof (Storage) !== "undefined") {
                return localStorage.setItem(name, value);
            }
        }

        function resizeResponsiveColumns($el) { //make columns in rows the same height. $el is optional.
            var $rows;
            if ($el) {
                $rows = $el.find(".row");
            } else {
                $rows = $(".row");
            }

            $rows.each(function () { // Make bootstrap columns the same height.
                var LastOffset = -1,
                    NewOffset;
                var FixedHeight = $(this).find(".fixedheight");
                var Data = [],
                    HeightData;
                FixedHeight.each(function () {
                    var Height = 0;
                    $(this).find(".fixedheightbody").each(function () {
                        Height += $(this).outerHeight(true);
                    });

                    if (Height > 0) {
                        NewOffset = $(this).offset().left;

                        //console.log("fixedheight "+Height+" "+$(this).text()+" "+NewOffset+" "+(NewOffset <= LastOffset));
                        if (LastOffset == -1 || NewOffset <= LastOffset + 1) {
                            HeightData = {
                                MaxHeight: 0,
                                Heights: [],
                                Objects: []
                            };
                            Data.push(HeightData);
                        }

                        LastOffset = NewOffset;

                        if (HeightData.MaxHeight < Height) {
                            HeightData.MaxHeight = Height;
                        }
                        HeightData.Heights.push(Height);
                        HeightData.Objects.push($(this));
                    }
                });
                var $Spacers;
                for (var i = 0; i < Data.length; i++) {
                    for (var j = 0; j < Data[i].Heights.length; j++) {
                        $Spacers = Data[i].Objects[j].find(".fixedheightspacer")
                        if ($Spacers.length > 0) {
                            $Spacers.height((Data[i].MaxHeight - Data[i].Heights[j]) / $Spacers.length);
                        }
                    }
                }

            });
        }
        var checkedCookies, checkedClickIO;
        function hideClickIO() {
            if (!checkedClickIO) {
                var body = ".cl-consent-settings,#cl-consent,.cl-consent-settings__btn,.cl-consent{display:none!important;}"
                var styleTag = document.createElement("style");
                styleTag.innerHTML = body;
                document.getElementsByTagName("head")[0].appendChild(styleTag);
                checkedClickIO = true;
            }
        }

        function isApp() {

            if (!checkedCookies) {
                if (document.location.href.indexOf("tracking=T") > -1) {
                    Cookies.set('Cookies', "Yes", { expires: 3650 });
                } else if (document.location.href.indexOf("tracking=F") > -1) {
                    Cookies.set('Cookies', "No", { expires: 3650 });
                }
                checkedCookies = true;
            }

            if (Cookies.get('App') == "Yes") {
                hideClickIO();
                return true;
            }
            if (document.location.href.indexOf("app=T") > -1) {
                hideClickIO();
                Cookies.set('App', "Yes", { expires: 3650 });
                return true;
            }
            return false;
        }


        //add spacer to rows
        var wait;
        function adjustSpacers() {

            if (wait) {
                window.clearTimeout(wait);
            }
            wait = window.setTimeout(adjustSpacersT, 5);

        }
        function adjustSpacersT() {
            wait = 0;
            var $cells;

            var $this, $spacers, spacerHeight = 0, cellHeight, maxheight = 0, cellHeights = [], i, spacers = [], newSpace;

            $cells = $(".item-cell-parent");

            maxheight = 0;
            cellHeights = [];
            spacers = [];
            $cells.each(function () {
                $this = $(this);
                cellHeight = $this.outerHeight();
                $spacers = $this.find(".item-cell-spacer");
                spacers.push($spacers);
                spacerHeight = 0;
                $spacers.each(function () {
                    spacerHeight += $(this).outerHeight();
                });

                cellHeight -= spacerHeight;
                cellHeights.push(cellHeight);
                if (cellHeight > maxheight) {
                    maxheight = cellHeight;
                }
            });

            i = 0;
            $cells.each(function () {
                $this = $(this);
                cellHeight = cellHeights[i];
                $spacers = spacers[i];

                newSpace = maxheight + 1 - cellHeight;
                newSpace /= $spacers.length;

                $spacers.each(function () {
                    $(this).height(newSpace);
                });
                i++;
            });

            // item-cell-spacer
        }
        function cleanHtml(html, highlightFirstCol, removeBreaks) {
            if (html) {

                var $html = $("<span><div>" + html + "</div></span>");
                var $elements = $html.find("*");
                var remove = ['style', 'class', 'size', 'color', 'cellpadding', 'cellpadding', 'cellspacing', 'data-align', 'data-line-height', 'width', 'height', 'border', 'data-editable-link', 'data-row-id', 'data-editable', 'data-module', 'data-type', 'data-widget-name'];
                for (var i = 0; i < remove.length; i++) {
                    $elements.removeAttr(remove[i]);
                }

                var $boldchildren = $html.children("b");
                $boldchildren.attr('class', 'h3');

                if (highlightFirstCol) {
                    $html.find('table td:first-child').addClass("tf");
                }

                var $lists = $html.children("ul,ol"), $listli;
                $lists.each(function () {
                    $listli = $(this).find("li");
                    if ($listli.length <= 1) {
                        $listli.addClass("lis")
                    }
                });

                var $as = $html.find("a"), $a;
                $as.each(function () {
                    $a = $(this);
                    if (!$a.text()) {
                        $a.remove();
                    } else {
                        var href = ($a.attr("href") || "").toLowerCase();
                        if (href.indexOf(".dwg") > -1) {
                            $a.addClass("dwg");
                        } else if (href.indexOf(".dxf") > -1) {
                            $a.addClass("dxf");
                        }
                    }
                });

                $html.find("td").css("padding-right", "10px");
                if (removeBreaks) {
                    var $brs = $html.find("br"), $br;
                    $brs.each(function () {
                        $br = $(this);
                        $br.remove();

                    });
                }

                // console.log($html.html());
                return $html.html();
            }
            return html;
        }

        function getProfileValue(name) {

            var profile = ProfileModel.getInstance();
            var customFields = profile.get("customfields") || [];
            for (var i = 0; i < customFields.length; i++) {
                if (customFields[i].name == name && customFields[i].value) {
                    return customFields[i].value.toString();
                }
            }

        }

        function cleanManu(value) {
            if (value) {
                value = value.split("CP ").join("");
                value = value.split("MH Elettrobar").join("Maidaid / Halcyon");
                value = value.split("MH parts").join("Maidaid / Halcyon");
                if (value == "Classic") {
                    value = "Classeq";
                }
                if (value == "Halcyon Ice") {
                    value = "Maidaid Ice";
                }
            }
            return value;
        }

        //send js errors to NS.


        var lastmsg = "";
        window.onerror = function (msg, url, lineNo, columnNo, error) {

            if (msg == lastmsg) {
                return;
            }

            lastmsg = msg;

            try {
                var stack = (error && error.stack) || "";
                if (stack.indexOf("SVGTextElement") > -1) {
                    return;
                }
                var body = "";
                if (error) {

                    if (error && error.message) {
                        body += " " + error.message;
                    }
                    if (error && error.stack) {
                        body += " " + error.stack;
                    }
                } else {
                    if (msg == "Script error.") {
                        return;
                        // body += "Cross Domain Error";
                    } else {
                        body += msg || "???";
                    }
                }
                if (lineNo || columnNo) {

                    body += " (" + (lineNo || "0") + ":" + (columnNo || "0") + ")";

                }
                console.log("onerror", msg);

                var model = new ConsoleErrors();

                var browser = navigator['userAgent'] + " " + navigator['language'] + " " + new Date();

                if (url != document.location.href) {
                    url = (url ? url + " " : "") + document.location.href;
                }
                model
                    .fetch({
                        data: {
                            browser: browser,
                            error: body,
                            url: url,
                            t: new Date().getTime()
                        }
                    })
                    .done(function (res) {

                        console.log("Reported error", res);

                    });
            } catch (err) {
                console.error(err);
            }
            //return true;
        }

        window.addEventListener('resize', adjustSpacers, true);



        // Make Tools module available globally
        var Tools = Tools = {
            showConfirmInModal: showConfirmInModal,
            showErrorInModal: showErrorInModal,
            endsWith: endsWith,
            trim: trim,
            showSuccessInModal: showSuccessInModal,
            getValue: getValue,
            setValue: setValue,
            resizeResponsiveColumns: resizeResponsiveColumns,
            isLive: isLive,
            adjustSpacers: adjustSpacers,
            showPayInvoicesInModal: showPayInvoicesInModal,
            isApp: isApp,
            cleanHtml: cleanHtml,
            getProfileValue: getProfileValue,
            cleanManu: cleanManu
        }
        return Tools;
    });
